import React, { useState, useEffect } from 'react';
import { Alert, Button, Modal } from 'react-bootstrap';
import { CardElement, useStripe, useElements } from '@stripe/react-stripe-js';
import { connect, useSelector } from 'react-redux';
import { subscribe } from '../../actions/setting-action';
import { STRIPE_ID } from '../../config';
import { useHistory, useLocation } from 'react-router-dom';
import { checkSub, getStripePlan } from '../../utils/SubUtils';
import * as Analytic from '../../utils/Analytic';
import { SUB_TIER } from '../../Const';

const CardForm = (props) => {
 
  const { isMonthly, cardHolder, subscribe, tier,subscriptionType } = props;
  const [success, setSuccess] = useState(false);
  const [orderId, setOrderId] = useState(0);
  const [error, setError] = useState(null);
  const [subscribing, setSubscribing] = useState(false);
  const [showSuccessDialog, setShowSuccessDialog] = useState(false);
  const location = useLocation();

  const subscription = useSelector(
    (state) => state.auth.user.user_subscription
  );
  const { subPremium, subTier } = checkSub(subscription);

  const stripe = useStripe();
  const elements = useElements();
  const history = useHistory();
  useEffect(() => {
    if (success) {
      history.push(
       `/rented-strategies?subscriptionSuccess=true`,
        { from: location }
      );
    } else if (subPremium && subTier === SUB_TIER.pro) {
      //redirectBack();
    }
  }, [success]);

  const redirectBack = () => {
    history.push('/setting?loc=2');
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!stripe || !elements) {
      return;
    }

    const cardElement = elements.getElement(CardElement);

    const { error, paymentMethod } = await stripe.createPaymentMethod({
      type: 'card',
      card: cardElement,
    });

    if (error) {
      setError(String(error.message));
    } else {
      setSubscribing(true);
      subscribe(
        paymentMethod.id,
        getStripePlan(subscriptionType, tier),
        cardHolder,
        tier
      )
        .then((order_id) => {
          setOrderId(order_id)
          Analytic.sendEvent(Analytic.subscribeSuccess);
          setSuccess(true);
          setSubscribing(false);
        })
        .catch((err) => {
          setError(err);
          setSubscribing(false);
        });
    }
  };

  return (
    <>
      <form onSubmit={handleSubmit}>
        <div className="mb-5">
          <label className="font-weight-bold">Card Number</label>
          <CardElement options={CARD_ELEMENT_OPTIONS} />
        </div>
        <div className="">
          <Button
            type="submit"
            disabled={!stripe || subscribing}
            variant="outline-success"
            className="w-100"
          >
            {subscribing ? 'Processing..' : 'Confirm'}
          </Button>
          <Alert
            show={success || error != null}
            variant={success ? 'success' : 'danger'}
            className="mt-3"
          >
            {success ? 'Payment is success.' : error}
          </Alert>
        </div>
      </form>
      <Modal show={showSuccessDialog} onHide={() => redirectBack()}>
        <Modal.Header>
          <Modal.Title>Subscription Successful!</Modal.Title>
        </Modal.Header>
        <Modal.Body>You are now subscribed to Premium.</Modal.Body>
        <Modal.Footer>
          <Button variant="success" onClick={() => redirectBack()}>
            Back
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default connect(null, { subscribe })(CardForm);

const CARD_ELEMENT_OPTIONS = {
  style: {
    base: {
      color: '#002352',
      fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
      fontSmoothing: 'antialiased',
      fontSize: '16px',
      '::placeholder': {
        color: '#aab7c4',
      },
    },
    invalid: {
      color: '#fa755a',
      iconColor: '#fa755a',
    },
  },
  hidePostalCode: true,
};
